import * as React from 'react';
import Analytics from '@lib/Analytics';
import { ScreenReaderContent } from '@components/A11y'
import {
  SocialShareButtonsContainer,
  SocialShareButton,
  SocialShareButtonCopy,
  ShareImage,
} from './SocialShareButtons.elements';
import { cdnWithoutUrl } from '@css/constants';

export interface SocialShareButtonsProps {
  shareOptions: ShareButtonProps[]
}

export interface ShareButtonProps {
  medium: string;
  url?: string;
}

function copyLink() {
  navigator.clipboard.writeText(window.location.href).then(function() {
    alert('A link is copied to your clipboard -- please paste it to share it!');
  }, function(err) {
    console.error('Failed to copy text.');
  });
}

export const SocialShareInnerContent: React.FunctionComponent<SocialShareButtonsProps> = ({shareOptions}) => {

  if (!shareOptions) {
    return null;
  }

  const twitterOptions = shareOptions.find(s => s.medium === 'twitter');
  const facebookOptions = shareOptions.find(s => s.medium === 'facebook');
  const emailOptions = shareOptions.find(s => s.medium === 'email');

  const onShare = (e, type) => {
    e.preventDefault();
    const option = shareOptions.find(s => s.medium === type);
    Analytics.log('Share', { medium: type });

    if(type !== 'link'){
      setTimeout(() => {
        window.open(option?.url, '_blank');
      }, 500);
    }else{
      copyLink();
    }
  }

  const onShareFb = (e) => {
    onShare(e, 'facebook');
  }

  const onShareTwitter = (e) => {
    onShare(e, 'twitter');
  }

  const onShareLink = (e) => {
    onShare(e, 'link');
  }

  const onShareEmail = (e) => {
    onShare(e, 'email');
  }

  return (
    <div>
      <SocialShareButton onClick={onShareTwitter} href={twitterOptions?.url} target="_blank">
        <ScreenReaderContent>Twitter</ScreenReaderContent>
        <ShareImage
          src={cdnWithoutUrl('quiz/icn40-share-twitter.svg')}
          alt="Twitter logo"
        />
      </SocialShareButton>
      <SocialShareButton onClick={onShareFb} href={facebookOptions?.url} target="_blank">
        <ScreenReaderContent>Facebook</ScreenReaderContent>
        <ShareImage
          src={cdnWithoutUrl('quiz/icn40-share-facebook.svg')}
          alt="Facebook logo"
        />
      </SocialShareButton>
      <SocialShareButtonCopy onClick={onShareLink}>
        <ScreenReaderContent>Copy link to share</ScreenReaderContent>
        <ShareImage
          src={cdnWithoutUrl('quiz/icn40-share-link.svg')}
          alt="Link to share"
        />
      </SocialShareButtonCopy>
      <SocialShareButton onClick={onShareEmail} href={emailOptions?.url}>
        <ScreenReaderContent>Email</ScreenReaderContent>
        <ShareImage
          src={cdnWithoutUrl('quiz/icn40-share-email.svg')}
          alt="Email logo"
        />
      </SocialShareButton>
    </div>
  );
}

export const SocialShareButtons: React.FunctionComponent<SocialShareButtonsProps> = (props) => {

  return (
    <SocialShareButtonsContainer>
      <SocialShareInnerContent {...props} />
    </SocialShareButtonsContainer>
  );
}
